<div class="p-12 panel-wrapper">
  <div class="flex flex-gap-8">
    <svg-icon class="color-error align-self-baseline flex-shrink-none m-t-4" key="lock-closed" size="md" />
    <div class="color-red-dark" [innerHTML]="message"></div>
  </div>
  @if (displayButtons) {
    <div class="flex-row flex-gap-8 m-l-24">
      <button class="btn btn-primitive opaque" (click)="eventSubmit.emit('remove')">
        <svg-icon class="m-r-8 color-green-dark" key="lock-open" size="md" />
        Remove from quarantine
      </button>

      <button class="btn btn-primitive opaque" (click)="eventSubmit.emit('extend')">
        <svg-icon class="m-r-8 color-gray" key="time" size="md" />
        Extend quarantine
      </button>
    </div>
  }
</div>
